import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        canManageCourse: '<',
        trainingForm: '=',
        key: '<',
        isDisabled: '<',
        ckconfig: '<',
        trainingTypes: '<',
        course: '<'
    },
    template: `
        <div class="mt20">
            <file-file-manager
                entity-type="'course_training'"
                entity-id="vm.trainingForm.id"
                course-id="vm.course.id">
            </file-file-manager>
        </div>
        <br />
        <div class="heading01">
            <h3>{{ 'courses.Learning materials' | translate }}</h3>
        </div>
        <form-row error="vm.form.errors.courseTrainings[vm.key].learndashCourseId">
            <label class="label">{{ 'courses.Learning materials' | translate }}</label>
            <div class="items">
                <select ng-disabled="vm.isDisabled" class="form-control"
                    ng-model="vm.trainingForm.learndashCourseId"
                    ng-change="vm.CourseVersionTrainingFormLearndashService.getLearndashCourse(vm.trainingForm)"
                    ng-options="course.ID as course.post_title for course in vm.CourseVersionTrainingFormLearndashService.learndashCourses">
                    <option value=""></option>
                </select>
                <p class="desc warn" ng-if="!vm.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(vm.trainingForm.learndashCourseId)">
                    {{ 'courses.Saved value is not displayed. You do not have access to the attached material' | translate }}
                </p>
            </div>
        </form-row>
    `
})

export default class {
    constructor (TokenService, CourseVersionService, CourseVersionTrainingFormFileService, CourseVersionTrainingFormLearndashService,
                COURSE_TRAINING_PASSING_TYPE_ENUM, ModalService, $translate) {
        this.TokenService = TokenService;
        this.CourseVersionService = CourseVersionService;
        this.CourseVersionTrainingFormFileService = CourseVersionTrainingFormFileService;
        this.CourseVersionTrainingFormLearndashService = CourseVersionTrainingFormLearndashService;
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.loading = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/additional/webinar/index.js